import { useState } from "react";
import { CloseIcon } from "../../../common/functions";

let positionInfoFields = ["id", "BB Ticker", "ISIN", "Location", "Currency", "Notional Amount", "Mid", "Average Cost", "Type", "Maturity", "Call Date", "Issuer", "Broker", "Country", "Sector", "Asset Class"];

function HidePosition(props: any) {
  let [reason, setReason] = useState("");

  if (!props.position["BB Ticker"]) {
    return <div></div>;
  }

  let notional = parseFloat(props.position["Notional Amount"]) || 0;
  // CDS prices are also stored as decimals (1.0653 = 106.53 points), so the
  // points-style display applies to them too.
  let isBond = props.position["Type"] == "BND" || props.position["Type"] == "UST" || props.position["Type"] == "CDS";
  let mid = parseFloat(props.position["Mid"]) || 0;
  let midDisplay = isBond ? (mid * 100).toFixed(4) : mid.toFixed(4);

  let formatNumber = (value: any) => {
    let num = parseFloat(value);
    if (isNaN(num)) return String(value || "");
    return num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  let getDisplayValue = (field: string, value: any) => {
    if (field == "Notional Amount") return formatNumber(value);
    if (field == "Mid") return midDisplay;
    if (field == "Average Cost") return (parseFloat(value) || 0).toFixed(4);
    return String(value !== undefined && value !== null ? value : "");
  };

  return (
    <div className="edit-position-modal">
      <div className="edit-position-header">
        <h3 className="edit-position-title">Move to Stale Positions: {props.position["BB Ticker"]}</h3>
        <div onClick={(event) => props.onCancel(event)} className="close-icon-container-edit-position">
          <CloseIcon />
        </div>
      </div>

      <form id="hide-position-form" onSubmit={(event) => props.onSubmit(event, reason)}>
        <div className="edit-position-grid">
          <div className="edit-section">
            <div className="edit-section-title">Position Details</div>
            <div className="edit-section-fields">
              {positionInfoFields.map((field) => {
                let value = props.position[field];
                return (
                  <div className="edit-field-row" key={field}>
                    <label className="edit-field-label">{field}</label>
                    <input type="text" className="edit-position-input" value={getDisplayValue(field, value)} disabled />
                  </div>
                );
              })}
            </div>
          </div>

          <div className="edit-section">
            <div className="edit-section-title">Hide Action</div>
            <div className="edit-section-fields">
              <div className="edit-field-row">
                <label className="edit-field-label">Reason for Moving to Stale *</label>
                <input
                  type="text"
                  name="reason"
                  className="edit-position-input"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="e.g. Missing sell VCON, awaiting broker confirmation"
                  required
                />
              </div>
            </div>
          </div>

          <div className="edit-section">
            <div className="edit-section-title">What Happens</div>
            <div className="edit-section-fields">
              <div className="edit-field-row">
                <label className="edit-field-label">Action</label>
                <input type="text" className="edit-position-input" value="Position removed from current portfolio snapshot" disabled />
              </div>
              <div className="edit-field-row">
                <label className="edit-field-label">P&L Impact</label>
                <input type="text" className="edit-position-input" value="Unrealized P&L, accrued interest stop calculating" disabled />
              </div>
              <div className="edit-field-row">
                <label className="edit-field-label">Historical Data</label>
                <input type="text" className="edit-position-input" value="All previous snapshots preserved" disabled />
              </div>
              <div className="edit-field-row">
                <label className="edit-field-label">Recovery</label>
                <input type="text" className="edit-position-input" value="Restore or Resolve with VCON from Stale Positions tab" disabled />
              </div>
            </div>
          </div>
        </div>

        <div className="edit-position-footer">
          <button type="button" className="btn btn-cancel" onClick={(event) => props.onCancel(event)}>
            Cancel
          </button>
          <button type="submit" className="btn upload-btn">
            Confirm Move to Stale
          </button>
        </div>
      </form>

      {props.authStatus && <div className="edit-position-error">{props.authStatus}</div>}
    </div>
  );
}

export default HidePosition;
